const SENDMAIL_API_URL = process.env.NEXT_PUBLIC_SENDMAIL_ENDPOINT;

export interface SendMailPayload {
	to: string;
	subject: string;
	/** Tableau de paires clé/valeur sérialisé en JSON */
	content: string;
	tag: string;
}

export const sendMailService = {
	async send(payload: SendMailPayload) {
		const response = await fetch(SENDMAIL_API_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			throw new Error(`Erreur sendMailWp: ${response.status}`);
		}

		return response.json();
	},
};
